import React from "react";
import PropTypes from "prop-types";
import { useMissionRoleApplicant } from "hooks";
import { MessagesError } from "components/Messages";
import ApplicationRequirements from "./ApplicationRequirements";
import { Grid } from "components/Containers";
import ApplicantSectionWithTitle from "./ApplicantSectionWithTitle";

/**
 * ApplicantTrustAndVerification
 *
 * @param {Object} application Accepted Employment Requirements
 */
const ApplicantTrustAndVerification = ({ application }) => {
  const { loading, data, error } = useMissionRoleApplicant({ id: application?.id });

  if (error) return <MessagesError />;

  return (
    <Grid>
      <Grid.col start={1} end={13}>
        <ApplicantSectionWithTitle titleMsgId="Missions.Applicants.ApplicantTrustAndVerification.TrustAndVerification">
          <ApplicationRequirements application={data} showMissingRequirements loading={loading} />
        </ApplicantSectionWithTitle>
      </Grid.col>
    </Grid>
  );
};

ApplicantTrustAndVerification.propTypes = {
  application: PropTypes.object.isRequired,
};

export default ApplicantTrustAndVerification;
